import ButtonV2, { getButtonClasses } from "components/elements/buttonV2"
import PropTypes from "prop-types"
import React from "react"
import { renderClasses } from "utils/renderClasses"

import "./calls-to-action.scss"

const CallsToAction = ({
  callsToAction,
  isWholeChild,
  menuOpen,
  menuToggleHandler,
}) => {
  return (
    <div
      className={renderClasses("g-header-top-nav-ctas", [[menuOpen, "--open"]])}
    >
      {callsToAction?.length > 0 && (
        <div className="g-header-top-nav-ctas-buttons">
          {callsToAction.map(callToAction => (
            <ButtonV2
              className={getButtonClasses(
                callToAction.buttonStyle,
                callToAction.buttonSize
              )}
              href={callToAction.path}
              key={callToAction.path}
              showArrow={callToAction?.showArrow === "Yes" ? true : false}
              text={callToAction.text}
            />
          ))}
        </div>
      )}

      <button
        aria-label={menuOpen ? "Close menu" : "Open menu"}
        className={renderClasses("g-header-top-nav-ctas-hamburger", [
          [menuOpen, "--open"],
          [isWholeChild, "--white"],
        ])}
        onClick={menuToggleHandler}
      >
        <span>{menuOpen ? "Close" : "Open"}</span>
      </button>
    </div>
  )
}

CallsToAction.propTypes = {
  callsToAction: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      accessibilityLabel: PropTypes.string,
      href: PropTypes.string,
      text: PropTypes.string,
      buttonStyle: PropTypes.arrayOf(PropTypes.string),
      buttonSize: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  isWholeChild: PropTypes.bool,
  menuOpen: PropTypes.bool,
  menuToggleHandler: PropTypes.func,
}

export default CallsToAction
